module.exports = __webpack_public_path__ + "img/team-2.4daf3e1f.jpg";